import { render, staticRenderFns } from "./StatusView.vue?vue&type=template&id=a675fdec"
import script from "./StatusView.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatusView.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports